import { render, staticRenderFns } from "./DettaglioParente.vue?vue&type=template&id=307aa378&"
import script from "./DettaglioParente.vue?vue&type=script&lang=js&"
export * from "./DettaglioParente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports